import { useId, useRef, useState } from 'react';
import type { Visibility } from '../../core/types';
import { AUDIENCE } from '../format';

/**
 * The one stable link (R11), who it reaches right now, and a copy button. `onCopied` fires once
 * per copy that worked; a browser that refuses the clipboard gets the link selected instead.
 */
export function ShareLink({ url, visibility, onCopied }: { url: string; visibility: Visibility; onCopied(): void }) {
  const id = useId();
  const field = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState<'yes' | 'select' | null>(null);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied('yes');
      onCopied();
    } catch {
      field.current?.select();
      setCopied('select');
    }
  };
  return <div className="share-link">
    <label htmlFor={id}>Your profile link</label>
    <div className="share-row">
      <input ref={field} id={id} type="text" readOnly value={url} onFocus={(e) => e.target.select()} />
      <button type="button" className="secondary" onClick={() => void copy()}>Copy link</button>
    </div>
    <p className="share-audience" data-testid="share-audience">{AUDIENCE[visibility].line}</p>
    <p className="share-status" role="status">{copied === 'yes' ? 'Link copied' : copied === 'select' ? 'Select the link and copy it.' : ''}</p>
  </div>;
}
